import { useState, useCallback } from 'react';
import api from '../api/client';

const usePostURL = () => {
  const [isGrabando, setGrabando] = useState(false);
  const [erroresPost, setErroresPost] = useState(null);

  const postData = useCallback(async (path, datos, datosGrabados) => {
    setGrabando(true);
    setErroresPost(null);
    try {
      const res = await api.post(path, datos);

      if (res.ok) {
        // prefer Location header if present, else data
        const location = res.headers?.get?.('Location') ?? null;
        datosGrabados(location ?? res.data ?? null);
      } else {
        setErroresPost(res.errors ?? ['Error al actualizar los datos']);
      }
    } catch (error) {
      console.error('Error Post', error.message ?? error);
      setErroresPost(['Error al actualizar los datos']);
    }
    setGrabando(false);
  }, []);

  const resetErroresPost = useCallback(() => {
    setErroresPost(null);
  }, []);

  return { isGrabando, erroresPost, postData, resetErroresPost };
};

export default usePostURL;
